//权益卡-免广告界面
const MonthTicketManager = require("./MonthTicketManager");

let MonthTicketAdPanel = xClass("MonthTicketAdPanel", BasePanel, function () {
    return cc.CSLoader.createNode("cocos/ticket_ticket_adblock.csb")
})
const RES = [
    "packed/MonthTicketAd.pack"
]
//购买月卡
MonthTicketAdPanel.show = function (successCb, failCb, adPos) {
    function onSuccess() {
        MonthTicketAdPanel.create(successCb, failCb, adPos)
    }
    preloadWithLoading(RES, onSuccess, function () {
        Toast.make(getText("error.tip.load_res_error"))
        failCb && failCb()
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
        failCb && failCb()
    })
}

MonthTicketAdPanel.prototype.ctor = function (successCb, failCb, adPos) {
    let self = this;
    BasePanel.prototype.ctor.call(self);
    self.popup();
    self.adPos = adPos;

    self.mgr = MonthTicketManager.getInstance();
    self.mgr.adPanel = self;
    self.successCb = successCb;
    self.failCb = failCb;
    self.initUI();
}

MonthTicketAdPanel.prototype.initUI = function () {
    let self = this;
    self.okBtn = self.getChildByName("btn_orange");
    self.noBtn = self.getChildByName("btn_green");
    self.com_close = self.getChildByName("com_back");

    self.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    DCAssist.dc4User101(ModuleName.MONTH_TICK, "privilege_force_show", {
        session: self.session,
        info: self.adPos,
    })

    quickBuildUIButton(self.okBtn, function () {
        if (!self.isBusy) {
            self.isBusy = true;
            self.failCb && self.failCb();
            DCAssist.dc4User101(ModuleName.MONTH_TICK, "privilege_force_click", {
                session: self.session,
                type: "continue",
            })
            self.onClose();
        }
    });

    quickBuildUIButton(self.noBtn, function () {
        if (!self.isBusy) {
            self.isBusy = true;
            function openCb() {
                self.isBusy = false;
            }
            DCAssist.dc4User101(ModuleName.MONTH_TICK, "privilege_force_click", {
                session: self.session,
                type: "check",
            })
            self.mgr.showMainPanel(openCb, openCb,"privilege_force");
        }
    });

    quickBuildUIButton(self.com_close, function () {
        if (!self.isBusy) {
            self.isBusy = true;
            self.failCb && self.failCb();
            DCAssist.dc4User101(ModuleName.MONTH_TICK, "privilege_force_click", {
                session: self.session,
                type: "close",
            })
            self.onClose();
        }
    });
}

MonthTicketAdPanel.prototype.onBuySuc = function () {
    let self = this;
    self.isBusy = false;
    if(self.mgr.tryPanel) {
        self.mgr.tryPanel.onClose();
    }
    if(self.mgr.mainPanel) {
        self.mgr.mainPanel.onClose();
    }
    self.successCb && self.successCb();
    self.onClose();
}

MonthTicketAdPanel.prototype.onClose = function (cb) {
    let self = this;
    self.mgr.adPanel = null;
    BasePanel.prototype.onClose.call(self, cb);
}

module.exports = MonthTicketAdPanel